'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsStatuses', ['$scope', 'IPStatuses', function ($scope, IPStatuses) {
        $scope.loading = true;

        IPStatuses.get().then(function (statuses) {
            $scope.statuses = statuses;
            $scope.loading = false;
        })

        $scope.columns = [
            {
                label: 'Sort Order',
                field: 'sort_order',
                type: 'sort_order'
            },
            {
                label: 'Name',
                field: 'name',
                link: {
                    state: 'internal.inspecting.resource.status',
                    params: [
                        {
                            name: 'id',
                            field: 'id'
                        },
                        {
                            name: 'status',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Last Modified',
                field: 'modifiedon',
                type: 'date'
            },
            {
                label: 'Modified By',
                field: 'modifiedby'
            }
        ];
    }])
;